import Program from './Program.vue';

export default Program;



// WEBPACK FOOTER //
// ./src/pages/professions/card/program/index.ts